export default __webpack_public_path__ + "static/media/normal.0edce0c4.jpg";